import React, { useRef } from 'react';

const SeoServicesSlider = () => {
  return (
    <div className={'trick-line'}>
      <div className={' ticker-line-container lg:hidden z-10 leading-[20px]'}>
        <div className="ticker-line">
          <div className="pr-[15px] md:pl-[15px]">
            <p className="flex items-center justify-center gap-[10px]">
              <span className="text-[24px] text-[#0052B4] font-[600]">96% </span>
              Client Satisfaction Score |
            </p>
          </div>
          <div className="pr-[15px] md:pl-[15px]">
            <p className="flex items-center justify-center gap-[10px]">
              <span className="text-[24px] text-[#D9A8E5] font-[600]">85% </span>
              Achieve Page 1 in 6 Months |
            </p>
          </div>
          <div className="pr-[15px] md:pl-[15px]">
            <p className="flex items-center justify-center gap-[10px]">
              <span className="text-[24px] text-[#F79E1B] font-[600]">300+ </span>
              Top-Ranked Keywords |
            </p>
          </div>
          <div className="pr-[15px] md:pl-[15px]">
            <p className="flex items-center justify-center gap-[10px]">
              <span className="text-[24px] text-[#FF4B55] font-[600]">90% </span>
              Client Traffic Boost
            </p>
          </div>
          <div className="pr-[15px] md:pl-[15px]">
            <p className="flex items-center justify-center gap-[10px]">
              <span className="text-[24px] text-[#0052B4] font-[600]">96% </span>
              Client Satisfaction Score |
            </p>
          </div>
          <div className="pr-[15px] md:pl-[15px]">
            <p className="flex items-center justify-center gap-[10px]">
              <span className="text-[24px] text-[#D9A8E5] font-[600]">85% </span>
              Achieve Page 1 in 6 Months |
            </p>
          </div>
          <div className="pr-[15px] md:pl-[15px]">
            <p className="flex items-center justify-center gap-[10px]">
              <span className="text-[24px] text-[#F79E1B] font-[600]">300+ </span>
              Top-Ranked Keywords |
            </p>
          </div>
          <div className="pr-[15px] md:pl-[15px]">
            <p className="flex items-center justify-center gap-[10px]">
              <span className="text-[24px] text-[#FF4B55] font-[600]">90% </span>
              Client Traffic Boost
            </p>
          </div>
          <div className="pr-[15px] md:pl-[15px]">
            <p className="flex items-center justify-center gap-[10px]">
              <span className="text-[24px] text-[#0052B4] font-[600]">96% </span>
              Client Satisfaction Score |
            </p>
          </div>
          <div className="pr-[15px] md:pl-[15px]">
            <p className="flex items-center justify-center gap-[10px]">
              <span className="text-[24px] text-[#D9A8E5] font-[600]">85% </span>
              Achieve Page 1 in 6 Months |
            </p>
          </div>
          <div className="pr-[15px] md:pl-[15px]">
            <p className="flex items-center justify-center gap-[10px]">
              <span className="text-[24px] text-[#F79E1B] font-[600]">300+ </span>
              Top-Ranked Keywords |
            </p>
          </div>
          <div className="pr-[15px] md:pl-[15px]">
            <p className="flex items-center justify-center gap-[10px]">
              <span className="text-[24px] text-[#FF4B55] font-[600]">90% </span>
              Client Traffic Boost
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SeoServicesSlider;
